import { ArrowLeft } from 'lucide-react'
import { StatusBadge } from './StatusBadge';

type orderDetailProps = {
  orderDetail: {
    JobTitle: string;
    status: string;
    designType?: string | null;
  },
  handleBack:()=>void
}

function CustomerHeader({ orderDetail,handleBack }: orderDetailProps) {

  return (
    <div className='flex justify-between items-center px-4 py-3 bg-white border border-[#E9EAEB] rounded-[8px] sticky top-0 md:top-4 z-50'>
      <div className='flex items-center gap-2'>
        <div className='border rounded-[4px] p-1 cursor-pointer hover:bg-gray-100 transition-colors'>
          <ArrowLeft size={12} strokeWidth={1} onClick={handleBack} />
        </div>
        <p className='text-body2 font-semibold text-gray-800'>{orderDetail.JobTitle}</p>
        {orderDetail.designType && (
          <span className='text-caption1 text-gray-500 shrink-0'>· {orderDetail.designType}</span>
        )}
      </div>
      <div className='flex items-center gap-2'>
        <StatusBadge status={orderDetail.status} />
      </div>
    </div>
  )
}

export default CustomerHeader